<template>
  <a-form-model
    ref="editReportForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item
        :label="'Total assets (' + form.totalAssetsCurrency + ')'"
        class="mr-4 flex-1"
        prop="totalAssets"
      >
        <a-input-number v-model="form.totalAssets" class="w-full" />
      </a-form-model-item>
      <a-form-model-item
        :label="'Total investments (' + form.totalInvestmentsCurrency + ')'"
        class="flex-1"
        prop="totalInvestments"
      >
        <a-input-number v-model="form.totalInvestments" class="w-full" />
      </a-form-model-item>
    </div>
    <div
      v-for="(classReport, index) in form.classReports"
      :key="classReport.id"
    >
      <h3 class="text-2xl font-semibold">{{ classReport.className }}</h3>
      <div class="w-full flex">
        <a-form-model-item
          :label="'Share value (' + classReport.shareValueCurrency + ')'"
          :prop="'classReports.' + index + '.shareValue'"
          class="mr-4 flex-1"
        >
          <a-input-number v-model="classReport.shareValue" class="w-full" />
        </a-form-model-item>
        <a-form-model-item
          :label="'Dividend (' + classReport.dividendCurrency + ')'"
          :prop="'classReports.' + index + '.dividend'"
          class="flex-1"
        >
          <a-input-number v-model="classReport.dividend" class="w-full" />
        </a-form-model-item>
      </div>
    </div>
    <a-button type="primary" html-type="submit" :disabled="isSaving">
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    fundMonthlyReport: {
      query: gql`
        query GetFundMonthlyReport($fundId: Uuid!, $year: Int!, $month: Int!) {
          fundMonthlyReport(fundId: $fundId, year: $year, month: $month) {
            fund {
              currency
            }
            totalAssets {
              amount
              currency
            }
            totalInvestments {
              amount
              currency
            }
            classReports {
              class {
                id
                name
                currency
              }
              shareValue {
                amount
                currency
              }
              dividend {
                amount
                currency
              }
            }
          }
        }
      `,
      variables() {
        return {
          fundId: this.report.fundId,
          year: this.report.year,
          month: this.report.month,
        }
      },
      update(data) {
        this.form = {
          totalAssets: data.fundMonthlyReport.totalAssets
            ? data.fundMonthlyReport.totalAssets.amount
            : null,
          totalAssetsCurrency: data.fundMonthlyReport.totalAssets
            ? data.fundMonthlyReport.totalAssets.currency
            : data.fundMonthlyReport.fund.currency,
          totalInvestments: data.fundMonthlyReport.totalInvestments
            ? data.fundMonthlyReport.totalInvestments.amount
            : null,
          totalInvestmentsCurrency: data.fundMonthlyReport
            .totalInvestmentsCurrency
            ? data.fundMonthlyReport.totalInvestments.currency
            : data.fundMonthlyReport.fund.currency,
          classReports: data.fundMonthlyReport.classReports.map((r) => ({
            classId: r.class.id,
            className: r.class.name,
            shareValue: r.shareValue ? r.shareValue.amount : null,
            shareValueCurrency: r.shareValue
              ? r.shareValue.currency
              : r.class.currency,
            dividend: r.dividend ? r.dividend.amount : null,
            dividendCurrency: r.dividend
              ? r.dividend.currency
              : r.class.currency,
          })),
        }
      },
    },
  },
  data() {
    return {
      form: {
        totalAssets: null,
        totalAssetsCurrency: null,
        totalInvestments: null,
        totalInvestmentsCurrency: null,
        classReports: [],
      },
      isSaving: false,
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editReportForm.validate(async (valid) => {
        if (valid) {
          try {
            this.isSaving = true
            await this.$apollo.mutate({
              mutation: gql`
                mutation($input: UpdateFundMonthlyReportInput) {
                  updateFundMonthlyReport(input: $input) {
                    reportId
                  }
                }
              `,
              variables: {
                input: {
                  fundId: this.report.fundId,
                  year: this.report.year,
                  month: this.report.month,
                  totalAssets: this.form.totalAssets,
                  totalInvestments: this.form.totalInvestments,
                  classReports: this.form.classReports.map((r) => ({
                    classId: r.classId,
                    shareValue: r.shareValue,
                    dividend: r.dividend,
                  })),
                },
              },
            })
            this.isSaving = false
            this.$refs.editReportForm.resetFields()
            this.$emit('reportSaved', {
              year: this.form.year,
              month: this.form.month,
            })
            this.$apollo.queries.fundMonthlyReport.refetch()
          } catch (error) {
            this.$message.error(error.message)
            this.isSaving = false
          }
        } else {
          return false
        }
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancelButtonClicked')
      this.$refs.editReportForm.resetFields()
    },
  },
}
</script>

<style></style>
